import { useEffect, useState } from 'react'
import Flatpickr from 'react-flatpickr'
import monthSelect from 'flatpickr/dist/plugins/monthSelect'
import { formatDate } from '@/utils/date'
import 'flatpickr/dist/plugins/monthSelect/style.css'

const CheckDateRangeFilter = ({
    setDateRangeFilter,
    resetOn = [],
}) => {
    
    useEffect(() => {
        setStartDate(null)
        setEndDate(null)
    }, resetOn)
    
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    
    const handleFiltering = () => {
        if (!startDate && !endDate) return
        setDateRangeFilter({
            startDate: formatDate(startDate, 'YYYY-MM-DD'),
            endDate: formatDate(endDate, 'YYYY-MM-DD'),
        })
    }
    
    const clearFilters = () => {
        setStartDate(null)
        setEndDate(null)
        setDateRangeFilter({})
    }
    
    return (
        <div className="CheckDateRangeFilter flex gap-3 mt-2 items-end w-[50%]">
            <div className="flex-1 mb-0">
                <label>Starting Date</label>
                <Flatpickr
                    className="input input-bordered flatpickr-input"
                    value={startDate}
                    name="startDate"
                    options={{
                        maxDate: endDate,
                        plugins: [new monthSelect()],
                    }}
                    onChange={date => setStartDate(date[0])} />
            </div>
            <div className="flex-1 mb-0">
                <label>Ending Date</label>
                
                <Flatpickr
                    className="input input-bordered flatpickr-input"
                    value={endDate}
                    name="endDate"
                    options={{
                        minDate: startDate,
                        plugins: [new monthSelect()],
                    }}
                    onChange={date => setEndDate(date[0])} />
            </div>
            <button
                className="btn btn-primary"
                disabled={!startDate && !endDate}
                onClick={handleFiltering}>
                Filter
            </button>
            <button
                className="btn btn-secondary"
                disabled={!startDate && !endDate}
                onClick={clearFilters}>
                Clear
            </button>
        </div>
    )
}

export default CheckDateRangeFilter
